/**
 * Soft refresh signal for an open script editor.
 *
 * Approving a script proposal in chat changes the script on the server while
 * the editor stays mounted. Emit this after the approved change is applied so
 * the editor reconciles the fresh script in place instead of reloading. The
 * realtime mutation channel may deliver the same change; reconciling twice is
 * harmless, and this signal also covers sessions without that channel.
 */

export const SCRIPT_PROPOSAL_APPLIED_EVENT = "gail:script-proposal-applied";

export type ScriptProposalAppliedDetail = {
  scriptId: string;
};

export function notifyScriptProposalApplied(scriptId: string): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<ScriptProposalAppliedDetail>(SCRIPT_PROPOSAL_APPLIED_EVENT, {
      detail: { scriptId },
    })
  );
}
